module.exports = __webpack_public_path__ + "static/JensonRecut-Regular-webfont-1026fc433d15fc02bac4872e1b3e6ffc.woff2";